
export function getDataValue(data, key) {
  return key.split('.').reduce((o, i) => {
    if (o) return o[i]
  }, data)
}